function normalizeCpfCnpj(text: string) {
    return text.replaceAll('.', '').replaceAll('-', '').replaceAll('/', '');
}

export default normalizeCpfCnpj;
